import { createBrowserHistory, createMemoryHistory } from 'history';
import { _url } from './makeUrl'

const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

export const history = !canUseDOM ? createMemoryHistory({
    initialEntries: [_url()]
}) : createBrowserHistory({ basename: _url() });